<template>
  <div class="unavailable">
    <div class="unavailable-wrapper" v-show="recordsList.length">
      <van-list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div :key="index" class="item" v-for="(record, index) in recordsList" @click="jumpDetails">
            <div class="icon">
              <img alt src="../../../assets/img/red-bag.png" />
            </div>
            <div class="intro">
              <p>{{record.remark}}</p>
              <p>{{record.create_at}}</p>
            </div>
          <div class="price" v-if="record.type === 'add'">+{{ record.rebate }}</div>
          <div class="price decreament" v-else-if="record.type === 'sub'">-{{ record.rebate }}</div>
        </div>
      </van-list>
    </div>
    <nodata v-show="!recordsList.length && noRecords"></nodata>
  </div>
</template>

<script>
import Nodata from './NoData'
import { List } from 'vant'
let flag = false
export default {
  name: 'unavailable',
  components: {
    Nodata,
    VanList: List
  },
  data () {
    return {
      recordsList: [],
      noRecords: false,
      pageNum: 1,
      loading: false,
      finished: false
    }
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 300000
    })
    this.getRecords()
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getRecords(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    jumpDetails () { },
    async getRecords (pageNum) {
      this.loading = true
      const res = await this.$axios.get(`api/member/bill_experience/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.recordsList = [...this.recordsList, ...data]
          this.loading = false
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noRecords = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.unavailable-wrapper {
  padding: 0.20rem 0.24rem;
}
.item {
  height: 1.76rem;
  background-color: #FFFFFF;
  padding: 0 0.44rem;
  margin-bottom: 0.20rem;
  border-radius: 0.10rem;
  font-size: @fz22;
  .flex-between;

  .icon {
    width: 0.91rem;
    height: 1.11rem;
    flex-shrink: 0;
  }
  .intro {
    flex: 1 0;
    padding-left: 0.24rem;
    font-size: @fz22;
    p:nth-child(1) {
      color: #484848;
      .ellipsis2;
    }
    p:nth-child(2) {
      margin-top: 0.22rem;
      color: #B5B5B5;
      white-space: nowrap;
    }
  }

  .price {
    flex-shrink: 0;
    margin-left: 0.20rem;
    font-size: 0.42rem;
    color: @price;

    &.decreament {
      color: #4C7A16;
    }
  }
}
</style>
